import { Link } from "react-router-dom";
import AppCard from "@/components/base/AppCard";
import SectionHeading from "@/components/base/SectionHeading";
import { watchApps } from "@/mocks/movies";
import type { WatchApp } from "@/mocks/movies";

interface AppShowcaseProps {
  onDownload: (app: WatchApp) => void;
}

export default function AppShowcase({ onDownload }: AppShowcaseProps) {
  return (
    <section className="w-full max-w-page mx-auto px-4 md:px-8 mt-14 md:mt-20">
      <SectionHeading
        eyebrow="Watch Apps"
        title="看片APP推荐"
        description="按设备与使用习惯挑工具，手机、平板、电视大屏都有合适的选择。"
        moreTo="/app"
        moreLabel="全部应用"
      />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
        {watchApps.slice(0, 4).map((app) => (
          <AppCard key={app.id} app={app} onDownload={onDownload} />
        ))}
      </div>

      <div className="mt-4 rounded-lg border border-accent-200 bg-accent-50 p-4 md:p-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-sm text-accent-900 leading-6">
          下载按钮为演示状态，正式下载链接接入后将直接跳转官方渠道。
        </p>
        <Link
          to="/app"
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-accent-500 text-primary-950 text-sm whitespace-nowrap hover:bg-accent-400 transition-colors"
        >
          查看应用榜单
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}